import React from "react";
import { useDroppable } from "@dnd-kit/core";
import Icon from "@mdi/react";
import { mdiMenuDown, mdiMenuRight } from "@mdi/js";

const DroppableYearRow = ({ year, colSpan }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: year,
    data: {
      accepts: ["row"], // Specify what type of items can be dropped here
      year: year,
    },
  });

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling
  };

  return (
    <tr
      ref={setNodeRef}
      className='custom-table-head'
      onClick={handleClick}
      style={{
        cursor: "pointer",
        backgroundColor: isOver ? "rgba(0, 200, 0, 0.6)" : undefined,
      }}
    >
      <td className='text-center' style={{ borderRight: "none" }}></td>
      <td colSpan={colSpan} style={{ borderLeft: "none" }}>
        <span
          className='text-uppercase'
          style={{ fontSize: 13, fontWeight: 700 }}
        >
          Tahun {year}
        </span>
      </td>
    </tr>
  );
};

export default DroppableYearRow;
